<template>
  <aside class="ad-sidebar">
    <button
      v-for="item in navItems"
      :key="item.key"
      type="button"
      class="ad-side-item"
      :class="{ active: item.key === activeKey }"
      @click="onNav(item)"
    >
      {{ displayName(item) }}
    </button>
  </aside>
</template>

<script>
import { antidroneNav, resolveAntidroneActiveKey } from '@/data/antidroneNav';
import { isEnglishRoute, withLang } from '@/utils/lang';

export default {
  name: 'AntiDroneSidebar',
  props: {
    active: {
      type: String,
      default: ''
    }
  },
  computed: {
    isEnglish() {
      return isEnglishRoute(this.$route);
    },
    navItems() {
      return antidroneNav;
    },
    activeKey() {
      return this.active || resolveAntidroneActiveKey(this.$route);
    }
  },
  methods: {
    displayName(item) {
      if (this.isEnglish) return item.nameEn || item.name;
      return item.name;
    },
    onNav(item) {
      const baseQuery = { ...(item.query || {}) };
      // 能力矩阵英文需带 cuas，避免被当成英文热喷涂首页
      if (this.isEnglish && item.key === 'capability') {
        baseQuery.cuas = '1';
      }
      const query = withLang(baseQuery, this.$route);
      const hasQuery = Object.keys(query).length > 0;
      const targetPath = this.isEnglish && item.pathEn ? item.pathEn : item.path;
      const samePath = this.$route.path === targetPath;
      const sameCat = !item.query || !item.query.cat || this.$route.query.cat === item.query.cat;
      if (samePath && sameCat && this.$route.query.lang === query.lang) {
        if (item.key !== 'capability' || this.$route.query.cuas === query.cuas) {
          return;
        }
      }
      this.$router.push(hasQuery ? { path: targetPath, query } : { path: targetPath });
    }
  }
};
</script>

<style scoped>
.ad-sidebar {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.ad-side-item {
  width: 100%;
  border: none;
  outline: none;
  cursor: pointer;
  text-align: left;
  padding: 18px 20px;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.4;
  color: #1e40af;
  background: #dbeafe;
  transition: background 0.2s ease, color 0.2s ease;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

.ad-side-item:hover {
  background: #bfdbfe;
}

.ad-side-item.active {
  background: #1e40af;
  color: #fff;
}

@media (max-width: 1100px) {
  .ad-sidebar {
    flex-direction: row;
    flex-wrap: wrap;
  }

  .ad-side-item {
    width: auto;
    flex: 1 1 200px;
  }
}
</style>
